import { createApp } from "vue";
import App from "./app.vue";
import router from "./router";
import { createSdkService, sdkService } from "./service/sdk";
import "./service/http";

import { install } from "nebula-mobile";
import "./style/index.scss";

import ArmsRum from "./service/arms";

const createServiceApp = async () => {
  const sdkOptions = await createSdkService();
  sdkService.showBackToPrevView(false);
  const app = createApp(App);
  app.use(router);
  app.use(install);
  app.mount("#app");
  ArmsRum.setConfig("user", {
    name: sdkOptions.nickname,
    tags: sdkOptions.open_id,
  });
};

createServiceApp();
